// Simple utility to combine class names
export function cn(...inputs) {
  return inputs.filter(Boolean).join(' ')
}

export const isIframe = typeof window !== 'undefined' && window.self !== window.top;

/**
 * Formats a phone number string into (XXX) XXX-XXXX format
 */
export function formatPhone(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  return phone; // fallback if not 10 or 11 digits
}
